export function formatJsDateToPt(date) {
  //return moment(date).format("DD/MM/YYYY");

  //verifica se é timestamp
  //console.log("FORMAT JS DATE TO PT: ")
  //console.log(date);

  if (!date) {
    return null;
  }

  if (date.seconds) {
    let dateAux = new Date();
    dateAux.setTime(date.seconds * 1000);
    date = dateAux;
  }

  return date.toLocaleDateString("pt-BR");
}

export function stringDateToJsDate(date) {
  let splittedDate = date.split("/");
  let myDate = new Date(splittedDate[2], parseInt(splittedDate[1]) - 1, splittedDate[0], 0, 0, 0, 0);

  return myDate;
}

export function difDates(d1, d2) {

  if (d1 == undefined || d2 == undefined) {
    return null
  }

  if (d1.toString().includes("/")) {
    d1 = stringDateToJsDate(d1);
  }

  //console.log("D2: " + d2);

  if (d2.toString().includes("/")) {
    d2 = stringDateToJsDate(d2);
  }

  let diffTime = d2.getTime() - d1.getTime();
  let diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

  return diffDays;
}


// WEBPACK FOOTER //
// src/utils/functions.js